import { ProviderCoding, JsonDiffReact } from '@enter/core';
import React from 'react';
import * as S from './claim-timeline-table.styles';

interface ICodingDetailProps {
    coding: ProviderCoding;
}

export const CodingDetail: React.FunctionComponent<ICodingDetailProps> = (
    props: ICodingDetailProps
): React.ReactElement => {
    const { coding } = props;

    let codingNotes = coding.notes;

    // Handle double encoded coding notes
    if (codingNotes) {
        try {
            codingNotes = JSON.parse(codingNotes);
        } catch (e) {
            // Keep original string if not JSON
        }
    }

    return (
        <S.ExpandWrap key={coding.id}>
            <S.ExpandCol>
                <S.ExpandTable expand={true}>
                    <S.ExpandTBody>
                        <S.ExpandTR>
                            <S.ExpandTH>Coding ID</S.ExpandTH>
                            <S.ExpandTD>{coding.id}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Vendor</S.ExpandTH>
                            <S.ExpandTD>{coding.vendor}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Status</S.ExpandTH>
                            <S.ExpandTD>{coding.status}</S.ExpandTD>
                        </S.ExpandTR>
                        {codingNotes && (
                            <S.ExpandTR>
                                <S.ExpandTH>Notes</S.ExpandTH>
                                <S.ExpandTD>
                                    <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                        {typeof codingNotes === 'string' ? codingNotes : JSON.stringify(codingNotes, null, 2)}
                                    </pre>
                                </S.ExpandTD>
                            </S.ExpandTR>
                        )}
                        <S.ExpandTR>
                            <S.ExpandTD colSpan={2}>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td>Before</td>
                                            <td>After</td>
                                            <td>Diff</td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', fontSize: '12px', fontFamily: "'Bitstream Vera Sans Mono', 'DejaVu Sans Mono', Monaco, Courier, monospace" }}>
                                                <pre>{coding.before ? JSON.stringify(coding.before, null, 4) : ''}</pre>
                                            </td>
                                            <td style={{ verticalAlign: 'top', fontSize: '12px', fontFamily: "'Bitstream Vera Sans Mono', 'DejaVu Sans Mono', Monaco, Courier, monospace" }}>
                                                <pre>{coding.after ? JSON.stringify(coding.after, null, 4) : ''}</pre>
                                            </td>
                                            <td style={{ verticalAlign: 'top' }}>
                                                <JsonDiffReact
                                                    right={coding.after}
                                                    left={coding.before}
                                                    show={false}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </S.ExpandTD>
                        </S.ExpandTR>
                    </S.ExpandTBody>
                </S.ExpandTable>
            </S.ExpandCol>
        </S.ExpandWrap>
    );
};

